import Vue from 'vue';
Vue.directive('permission', {
    inserted(el, binding) {
        const userType = binding.value.action
        if (userType != "ADMIN") {
            el.parentNode.removeChild(el)
        }

    }
})